export default __webpack_public_path__ + "static/media/firebase.141d4fe1.svg";